export default __webpack_public_path__ + "static/media/present.a507ea44.mp3";